module.exports = __webpack_public_path__ + "static/media/screen-behavioral-01.68119b83.jpg";